// components/LoadingSkeleton.jsx
import React from 'react';
import { Skeleton } from 'antd';

const LoadingSkeleton = ({ text = "Buscando..." }) => {
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      flexDirection: 'column',
      gap: 6
    }}>
      <Skeleton.Button 
        active 
        size="small" 
        style={{ width: '100%' }} 
      />
      <span style={{ 
        fontSize: '10px', 
        color: '#999',
        fontStyle: 'italic'
      }}>
        {text}
      </span>
    </div>
  );
};

export default LoadingSkeleton;
